/* =============================================
   NORDWALD MASTER INJECT v3.0
   Apple iOS 26 Design — Settings Homepage
   Widget Cards — Treue-Baum — Search Bar
   Apple Pay / Google Pay — Jetzt Kaufen
   ============================================= */
(function() {
'use strict';

// ── 1. COMPLETE CSS INJECTION ──────────────────
const css = `
:root {
  --nl: #1A5C3A;
  --nl2: #238B57;
  --nla: #E8F5EE;
  --nljade: #1A5C3A;
  --nljade2: #238B57;
  --nlg: rgba(255,255,255,0.72);
  --nlgb: rgba(255,255,255,0.92);
  --nlblur: blur(28px) saturate(200%);
  --nlr: 20px;
  --nlsh: 0 4px 24px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.95);
  --nlf: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', system-ui, sans-serif;
  --nls: cubic-bezier(0.32,0.72,0,1); /* Honig: kein Bounce, smooth decel */
}

/* === BODY === */
body {
  font-family: var(--nlf) !important;
  -webkit-font-smoothing: antialiased !important;
  background: #f8f8fa !important;
  background-attachment: fixed !important;
  overscroll-behavior: none;
}

/* === PAGE WIDTH === */
.page-width {
  max-width: 1380px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  margin: 0 auto !important;
}

/* === HEADER — sticky glass bar === */
.header-wrapper {
  background: #fff !important;
  border-bottom: 1px solid rgba(0,0,0,0.06) !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
  position: sticky !important; top: 0 !important; z-index: 200 !important;
}

/* === ANNOUNCEMENT BAR === */
.announcement-bar, .shopify-section-announcement {
  background: var(--nl) !important;
  font-weight: 650 !important;
  letter-spacing: -0.01em !important;
}

/* === TYPOGRAPHY === */
h1,.h1 { font-weight: 800 !important; letter-spacing: -0.04em !important; line-height: 1.06 !important; font-family: var(--nlf) !important; }
h2,.h2 { font-weight: 760 !important; letter-spacing: -0.03em !important; font-family: var(--nlf) !important; }
h3,.h3,.card__heading,.card__heading a {
  font-weight: 660 !important; letter-spacing: -0.02em !important;
  font-family: var(--nlf) !important;
  font-size: clamp(12px, 0.9vw, 15px) !important;
  line-height: 1.3 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
}
p,li,span,label,div { font-family: var(--nlf) !important; }

/* ============================================================
   PRODUCT CARDS — Apple Home Screen Widget Style
   ============================================================ */
.product-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)) !important;
  gap: 14px !important;
}
@media(min-width:768px) {
  .product-grid { grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)) !important; gap: 16px !important; }
}
@media(min-width:1200px) {
  .product-grid { grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)) !important; gap: 18px !important; }
}

.card-wrapper { border-radius: 14px !important; }
.card, .card__inner {
  background: #fff !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03) !important;
  overflow: hidden !important;
  transition: transform 0.45s var(--nls), box-shadow 0.4s ease !important;
  position: relative !important;
}
.card-wrapper:hover .card, .card-wrapper:focus-within .card {
  transform: translateY(-2px) !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06), 0 8px 24px rgba(0,0,0,0.05) !important;
}
.card:active { transform: translateY(-1px) !important; transition-duration: 0.15s !important; }

/* Widget-style image container */
.card__media, .card__media img {
  border-radius: 14px 14px 0 0 !important;
  aspect-ratio: 1 / 1 !important;
  object-fit: cover !important;
  width: 100% !important;
}
.card__content {
  padding: 10px 12px 12px !important;
}

/* === PRICE — Apple discount display === */
.price { font-weight: 720 !important; font-size: 15px !important; }
.price--on-sale .price-item--sale {
  color: var(--nl) !important;
  font-weight: 800 !important;
  font-size: 16px !important;
}
.price--on-sale .price-item--regular {
  color: rgba(0,0,0,0.35) !important;
  font-size: 12px !important;
  text-decoration: line-through !important;
}
/* Apple-style savings badge */
.card .price--on-sale::after {
  display: none;
}
.price-badge-savings {
  display: inline-block;
  background: linear-gradient(135deg, #FF3B30, #FF6B35);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 7px;
  border-radius: 100px;
  margin-left: 5px;
  vertical-align: middle;
  letter-spacing: -0.01em;
}

/* === BADGES === */
.badge {
  background: linear-gradient(135deg, var(--nl), var(--nl2)) !important;
  color: #fff !important;
  border-radius: 100px !important;
  padding: 3px 9px !important;
  font-weight: 780 !important;
  font-size: 10px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.3) !important;
  letter-spacing: -0.01em !important;
}

/* === BUTTONS — DoktorABC clean (flat green, no gradient) === */
.button, .btn, [type="submit"]:not(.shopify-payment-button__button--unbranded) {
  background: #1A5C3A !important;
  border: none !important;
  border-radius: 12px !important;
  font-family: var(--nlf) !important;
  font-weight: 660 !important;
  color: #fff !important;
  min-height: 50px !important;
  padding: 0 28px !important;
  font-size: 15px !important;
  letter-spacing: -0.01em !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.2), 0 6px 20px rgba(26,92,58,0.15), inset 0 1px 0 rgba(255,255,255,0.15) !important;
  transition: all 0.3s cubic-bezier(0.25,0.46,0.45,0.94) !important;
  position: relative !important;
  overflow: hidden !important;
  cursor: pointer !important;
}
.button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(26,92,58,0.3), 0 10px 28px rgba(26,92,58,0.2), inset 0 1px 0 rgba(255,255,255,0.18) !important;
  filter: brightness(1.06) !important;
}
.button:active { transform: translateY(0) scale(0.98) !important; transition-duration: 0.1s !important; }
.button::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.12) 0%, transparent 50%);
  pointer-events: none;
}
.button--secondary, .button--tertiary {
  background: rgba(26,92,58,0.06) !important;
  color: var(--nl) !important;
  border: 1.5px solid rgba(26,92,58,0.18) !important;
  box-shadow: none !important;
}
.button--secondary:hover, .button--tertiary:hover {
  background: rgba(26,92,58,0.10) !important;
  border-color: rgba(26,92,58,0.3) !important;
}

/* === ADD-TO-CART — DoktorABC full width === */
.product-form__submit {
  width: 100% !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 680 !important;
  letter-spacing: -0.01em !important;
  min-height: 54px !important;
  background: #1A5C3A !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.2), 0 8px 24px rgba(26,92,58,0.15) !important;
}

/* === CHECKBOXES === */
input[type="checkbox"] {
  appearance: none !important; -webkit-appearance: none !important;
  width: 22px !important; height: 22px !important;
  border: 2px solid rgba(26,92,58,0.25) !important;
  border-radius: 7px !important;
  background: rgba(255,255,255,0.8) !important;
  cursor: pointer !important;
  transition: all 0.2s var(--nls) !important;
  flex-shrink: 0 !important;
}
input[type="checkbox"]:checked {
  background: var(--nl) !important;
  border-color: var(--nl) !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'%3E%3Cpath d='M1 5l3 4L11 1' stroke='%23fff' stroke-width='2.2' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
  background-size: 12px !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}

/* === FILTER PANEL === */
.facets-container, .facets__form, .facets__wrapper {
  background: rgba(255,255,255,0.65) !important;
  backdrop-filter: var(--nlblur) !important;
  -webkit-backdrop-filter: var(--nlblur) !important;
  border: 1px solid var(--nlgb) !important;
  border-radius: var(--nlr) !important;
}
.facets__heading { font-weight: 740 !important; letter-spacing: -0.02em !important; }

/* === SORT DROPDOWN === */
.select__select {
  border-radius: 100px !important;
  border: 1.5px solid rgba(26,92,58,0.2) !important;
  font-weight: 640 !important;
  background: rgba(255,255,255,0.9) !important;
  padding: 10px 20px !important;
  font-family: var(--nlf) !important;
}

/* === PRODUCT FORM === */
.product-form {
  background: #fff !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 16px !important;
  padding: 24px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04) !important;
}

/* === FOOTER === */
.footer {
  background: rgba(8,8,20,0.97) !important;
  border-top: 1px solid rgba(26,92,58,0.12) !important;
}

/* === SCROLLBAR === */
::-webkit-scrollbar { width: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(26,92,58,0.22); border-radius: 100px; }
::-webkit-scrollbar-thumb:hover { background: rgba(26,92,58,0.45); }

/* === KILL OLD FIFTEEN-* ELEMENTS === */
canvas:not(#nw-confetti-canvas),
[id*="particle-canvas"],
[class*="particle-canvas"],
.fifteen-particle-wrap,
#vibe-canvas,
.fifteen-game-bar,
[class*="geheimrabatt"],
[id*="geheimrabatt"],
.jade-crystal,
[class*="jade-crystal"],
[class*="loot-drop"],
.loot-drop-template,
#nw-treue-orb,
#nw-treue-widget,
[class*="treue-orb"],
[class*="treue-widget"],
[class*="clicker"],
.fifteen-clicker,
.fifteen-hero,
.home-widgets,
.mob-toast {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

/* === CART PAGE — DoktorABC clean (URL-based) === */
.cart__empty-text,
.cart-page h1 {
  font-family: var(--nlf) !important;
  font-weight: 700 !important;
  letter-spacing: -0.02em !important;
  color: #1A3A2A !important;
}
/* "Weiter einkaufen" link-button on cart */
.title-wrapper-with-link .underlined-link,
a.underlined-link[href="/collections/all"] {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 14px 32px !important;
  background: var(--nl) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 12px !important;
  font-weight: 620 !important;
  font-size: 15px !important;
  letter-spacing: -0.01em !important;
  text-decoration: none !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.2) !important;
  font-family: var(--nlf) !important;
  transition: all 0.2s ease !important;
}
.title-wrapper-with-link .underlined-link:hover,
a.underlined-link[href="/collections/all"]:hover {
  background: var(--nl2) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 16px rgba(26,92,58,0.25) !important;
}
.cart-item, .cart__items {
  border-color: rgba(0,0,0,0.06) !important;
}
.totals, .cart__footer {
  font-family: var(--nlf) !important;
  border-top: 1px solid rgba(0,0,0,0.06) !important;
}
/* Hide old "Featured Collection" on cart page */
.cart-page ~ .shopify-section,
[id*="featured-collection"] {
  display: none !important;
}

/* === LOGIN/ACCOUNT PAGE === */
.field input,
input[type="email"],
input[type="password"],
.customer input {
  border-radius: 12px !important;
  border: 1.5px solid rgba(0,0,0,0.1) !important;
  padding: 14px 16px !important;
  font-family: var(--nlf) !important;
  font-size: 15px !important;
  background: #fff !important;
  transition: border-color 0.2s ease !important;
}
.field input:focus,
input[type="email"]:focus,
input[type="password"]:focus {
  border-color: var(--nl) !important;
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(26,92,58,0.1) !important;
}
.customer .button,
.customer a.button {
  background: var(--nl) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 12px !important;
  min-height: 50px !important;
  font-weight: 620 !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.2) !important;
}

/* ============================================================
   HOMEPAGE — DoktorABC Treatment-Card System
   ============================================================ */
body.template-index .main-content,
body.page-type--index .main-content {
  padding: 0 !important;
}

/* ── Search Bar (DoktorABC exact) ── */
#nw-search-bar {
  padding: 12px 20px 10px !important;
  background: #fff !important;
  border-bottom: 1px solid rgba(0,0,0,0.06) !important;
  position: sticky !important; top: 0 !important; z-index: 199 !important;
}
#nw-search-inner {
  display: flex !important; align-items: center !important; gap: 10px !important;
  background: #f5f5f7 !important;
  border-radius: 12px !important;
  padding: 12px 16px !important;
  border: 1.5px solid transparent !important;
  transition: all 0.25s ease !important;
}
#nw-search-inner:focus-within {
  background: #fff !important;
  border-color: var(--nl) !important;
  box-shadow: 0 0 0 3px rgba(26,92,58,0.12) !important;
}
#nw-search-icon { color: rgba(60,60,67,0.4) !important; flex-shrink:0 !important; display:flex !important; }
#nw-search-input {
  flex: 1 !important; border: none !important; background: transparent !important;
  font-size: 15px !important; font-family: var(--nlf) !important;
  font-weight: 500 !important; color: #1c1c1e !important; outline: none !important;
}
#nw-search-input::placeholder { color: rgba(60,60,67,0.35) !important; }

/* ── Nav Pills (DoktorABC dark rounded) ── */
.nw-nav-pills {
  display: flex !important;
  gap: 8px !important;
  padding: 14px 16px !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;
  scrollbar-width: none !important;
}
.nw-nav-pills::-webkit-scrollbar { display: none !important; }
.nw-pill {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 10px 16px !important;
  background: #fff !important;
  color: #1A3A2A !important;
  border: 1px solid rgba(26,92,58,0.15) !important;
  border-radius: 100px !important;
  font-size: 13px !important;
  font-weight: 620 !important;
  font-family: var(--nlf) !important;
  white-space: nowrap !important;
  text-decoration: none !important;
  letter-spacing: -0.01em !important;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease !important;
  flex-shrink: 0 !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
}
.nw-pill:hover {
  background: #F0FAF4 !important;
  box-shadow: 0 2px 8px rgba(26,92,58,0.1) !important;
  transform: translateY(-1px) !important;
}
.nw-pill:active {
  transform: scale(0.97) !important;
  transition-duration: 0.1s !important;
}
.nw-pill svg { flex-shrink: 0 !important; }

/* ── Section Labels ── */
.nw-section-label {
  font-size: 22px !important;
  font-weight: 760 !important;
  color: #1c1c1e !important;
  letter-spacing: -0.03em !important;
  padding: 28px 20px 14px !important;
  font-family: var(--nlf) !important;
}
.nw-section-sub {
  font-size: 14px !important;
  color: rgba(60,60,67,0.55) !important;
  padding: 0 20px 16px !important;
  font-family: var(--nlf) !important;
  margin-top: -8px !important;
}

/* ── Promo Banner (DoktorABC hero image) ── */
.nw-promo-banner {
  margin: 0 16px 16px !important;
  border-radius: 16px !important;
  overflow: hidden !important;
  position: relative !important;
  min-height: 180px !important;
  display: flex !important;
  align-items: center !important;
  background: linear-gradient(135deg, #E8F5EE 0%, #F0FAF4 40%, #FAFFFE 100%) !important;
  border: 1px solid rgba(26,92,58,0.1) !important;
}
.nw-promo-bg {
  position: absolute !important;
  inset: 0 !important;
  background:
    radial-gradient(circle at 80% 50%, rgba(35,139,87,0.08) 0%, transparent 60%),
    radial-gradient(circle at 20% 80%, rgba(26,92,58,0.05) 0%, transparent 50%) !important;
  pointer-events: none !important;
}
.nw-promo-content {
  position: relative !important;
  z-index: 1 !important;
  padding: 24px 20px !important;
  flex: 1 !important;
}
.nw-promo-eyebrow {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: rgba(26,92,58,0.5) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  margin-bottom: 8px !important;
  font-family: var(--nlf) !important;
}
.nw-promo-headline {
  font-size: 22px !important;
  font-weight: 800 !important;
  color: #1A3A2A !important;
  letter-spacing: -0.03em !important;
  line-height: 1.15 !important;
  margin-bottom: 8px !important;
  font-family: var(--nlf) !important;
}
.nw-promo-sub {
  font-size: 13px !important;
  color: rgba(26,58,42,0.55) !important;
  line-height: 1.4 !important;
  margin-bottom: 16px !important;
  font-family: var(--nlf) !important;
  max-width: 280px !important;
}
.nw-promo-cta {
  display: inline-block !important;
  padding: 10px 20px !important;
  background: var(--nl) !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  border-radius: 100px !important;
  text-decoration: none !important;
  font-family: var(--nlf) !important;
  letter-spacing: -0.01em !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}
.nw-promo-cta:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.2) !important;
}
.nw-promo-visual {
  position: absolute !important;
  right: 12px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  opacity: 0.6 !important;
}
@media(max-width:480px) {
  .nw-promo-visual { display: none !important; }
  .nw-promo-headline { font-size: 20px !important; }
}

/* ── Hero Offer Card ── */
.nw-hero-offer {
  margin: 0 16px 20px !important;
  background: #fff !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.04) !important;
  cursor: pointer !important;
  transition: transform 0.3s cubic-bezier(0.32,0.72,0,1), box-shadow 0.3s ease !important;
  text-decoration: none !important;
  display: block !important;
  color: #1c1c1e !important;
}
.nw-hero-offer:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06), 0 12px 32px rgba(0,0,0,0.06) !important;
}
.nw-hero-inner {
  display: grid !important;
  grid-template-columns: 52px 1fr auto auto !important;
  align-items: center !important;
  padding: 18px 16px !important;
  gap: 12px !important;
}
.nw-hero-icon {
  width: 52px !important; height: 52px !important;
  border-radius: 14px !important;
  background: linear-gradient(135deg, rgba(26,92,58,0.08), rgba(26,92,58,0.03)) !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  flex-shrink: 0 !important;
}
.nw-hero-text { flex: 1 !important; min-width: 0 !important; }
.nw-hero-badge {
  display: inline-block !important;
  background: var(--nl) !important;
  color: #fff !important;
  font-size: 10px !important;
  font-weight: 750 !important;
  padding: 3px 8px !important;
  border-radius: 6px !important;
  letter-spacing: 0.04em !important;
  text-transform: uppercase !important;
  margin-bottom: 6px !important;
}
.nw-hero-title {
  font-size: 15px !important;
  font-weight: 700 !important;
  color: #1c1c1e !important;
  letter-spacing: -0.02em !important;
  font-family: var(--nlf) !important;
  margin-bottom: 2px !important;
  line-height: 1.3 !important;
}
.nw-hero-sub {
  font-size: 12px !important;
  color: rgba(60,60,67,0.55) !important;
  font-family: var(--nlf) !important;
  line-height: 1.3 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
}
.nw-hero-price {
  font-size: 16px !important;
  font-weight: 800 !important;
  color: var(--nl) !important;
  font-family: var(--nlf) !important;
  white-space: nowrap !important;
}
.nw-hero-arrow {
  color: rgba(60,60,67,0.25) !important;
  font-size: 20px !important;
  flex-shrink: 0 !important;
  transition: transform 0.2s ease !important;
}
.nw-hero-offer:hover .nw-hero-arrow { transform: translateX(3px) !important; color: var(--nl) !important; }

/* ── Trust Stats Row (DoktorABC) ── */
.nw-trust-stats {
  display: flex !important;
  justify-content: center !important;
  gap: 24px !important;
  padding: 16px 20px !important;
  margin: 0 16px 8px !important;
  background: #fff !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03) !important;
}
.nw-stat { text-align: center !important; }
.nw-stat-val {
  font-size: 18px !important; font-weight: 800 !important;
  color: var(--nl) !important; font-family: var(--nlf) !important;
  letter-spacing: -0.02em !important;
}
.nw-stat-label {
  font-size: 11px !important; color: rgba(60,60,67,0.45) !important;
  font-family: var(--nlf) !important; margin-top: 2px !important;
}

/* ── Treatment Card Grid (DoktorABC core) ── */
.nw-card-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 10px !important;
  padding: 0 16px 20px !important;
}
@media(min-width:480px) {
  .nw-card-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
}
@media(min-width:768px) {
  .nw-card-grid { grid-template-columns: repeat(3, 1fr) !important; gap: 14px !important; }
}

/* ── Treatment Card (DoktorABC exact replica) ── */
.nw-cat-card {
  background: #fff !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
  border-radius: 14px !important;
  padding: 18px 16px !important;
  text-decoration: none !important;
  color: #1c1c1e !important;
  display: grid !important;
  grid-template-columns: 48px 1fr 18px !important;
  grid-template-rows: auto !important;
  align-items: center !important;
  gap: 12px !important;
  cursor: pointer !important;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.03) !important;
  transition: transform 0.25s cubic-bezier(0.32,0.72,0,1), box-shadow 0.25s ease !important;
  position: relative !important;
  min-height: 72px !important;
}
.nw-cat-card:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06), 0 8px 20px rgba(0,0,0,0.05) !important;
}
.nw-cat-card:active {
  transform: translateY(0) scale(0.99) !important;
  transition-duration: 0.1s !important;
}

/* Icon: squared, subtle tint */
.nw-cat-icon {
  width: 48px !important; height: 48px !important;
  border-radius: 12px !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  flex-shrink: 0 !important;
}

/* Text block */
.nw-cat-text { flex: 1 !important; min-width: 0 !important; }
.nw-cat-title {
  font-size: 15px !important;
  font-weight: 660 !important;
  letter-spacing: -0.01em !important;
  color: #1c1c1e !important;
  font-family: var(--nlf) !important;
  line-height: 1.25 !important;
}
.nw-cat-sub {
  font-size: 12px !important;
  color: rgba(60,60,67,0.5) !important;
  font-family: var(--nlf) !important;
  line-height: 1.35 !important;
  margin-top: 2px !important;
}
.nw-cat-badge {
  display: inline-block !important;
  font-size: 9px !important;
  font-weight: 750 !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  letter-spacing: 0.05em !important;
  text-transform: uppercase !important;
  margin-top: 5px !important;
}
.nw-badge-neu { background: var(--nl) !important; color: #fff !important; }
.nw-badge-soon { background: rgba(26,92,58,0.08) !important; color: var(--nl) !important; }
.nw-badge-hot { background: rgba(255,59,48,0.1) !important; color: #FF3B30 !important; }

/* Chevron right (DoktorABC) */
.nw-cat-arrow {
  color: rgba(60,60,67,0.2) !important;
  transition: color 0.2s ease, transform 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.nw-cat-card:hover .nw-cat-arrow {
  color: var(--nl) !important;
  transform: translateX(2px) !important;
}

/* ============================================================
   TREUE-BAUM WIDGET
   ============================================================ */
#nw-treue-widget {
  position: fixed !important;
  bottom: 28px !important;
  right: 20px !important;
  z-index: 9999 !important;
  font-family: var(--nlf) !important;
}
#nw-treue-orb {
  width: 68px !important;
  height: 68px !important;
  border-radius: 50% !important;
  background: linear-gradient(145deg, rgba(26,92,58,0.92), rgba(48,209,88,0.85)) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  box-shadow: 0 8px 32px rgba(26,92,58,0.45), 0 2px 8px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.5) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: transform 0.45s var(--nls), box-shadow 0.3s ease !important;
  position: relative !important;
  font-size: 30px !important;
  user-select: none !important;
  -webkit-tap-highlight-color: transparent !important;
}
#nw-treue-orb:hover { transform: scale(1.02) !important; box-shadow: 0 14px 44px rgba(26,92,58,0.55), inset 0 1px 0 rgba(255,255,255,0.6) !important; }
#nw-treue-orb:active { transform: scale(0.97) !important; transition-duration: 0.15s !important; }

/* Spinning progress ring */
#nw-ring-svg {
  position: absolute !important;
  inset: -6px !important;
  width: calc(100% + 12px) !important;
  height: calc(100% + 12px) !important;
  pointer-events: none !important;
}
.nw-ring-bg { fill: none; stroke: rgba(26,92,58,0.2); stroke-width: 4; }
.nw-ring-progress {
  fill: none;
  stroke: #1A5C3A;
  stroke-width: 4;
  stroke-linecap: round;
  transform-origin: center;
  transform: rotate(-90deg);
  transition: stroke-dasharray 1.2s var(--nls) !important;
  filter: drop-shadow(0 0 4px rgba(26,92,58,0.7));
}
@keyframes nw-ring-spin {
  0% { transform: rotate(-90deg); }
  100% { transform: rotate(270deg); }
}

/* Badge on orb */
#nw-treue-badge {
  position: absolute !important;
  top: -4px !important; right: -4px !important;
  background: linear-gradient(135deg, #FF3B30, #FF6B35) !important;
  color: #fff !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  min-width: 20px !important;
  height: 20px !important;
  border-radius: 100px !important;
  display: flex !important; align-items: center !important; justify-content: center !important;
  padding: 0 5px !important;
  border: 2px solid #fff !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;
  font-family: var(--nlf) !important;
}

/* Expanded card */
#nw-treue-card {
  position: absolute !important;
  bottom: 78px !important;
  right: 0 !important;
  width: 280px !important;
  background: rgba(255,255,255,0.95) !important;
  backdrop-filter: blur(30px) saturate(200%) !important;
  -webkit-backdrop-filter: blur(30px) saturate(200%) !important;
  border: 1px solid rgba(255,255,255,0.98) !important;
  border-radius: 22px !important;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18), 0 4px 20px rgba(26,92,58,0.12), inset 0 1px 0 rgba(255,255,255,1) !important;
  padding: 20px !important;
  transform-origin: bottom right !important;
  transform: translateY(12px) !important;
  opacity: 0 !important;
  pointer-events: none !important;
  transition: all 0.35s cubic-bezier(0.32,0.72,0,1) !important;
}
#nw-treue-card.nw-open {
  transform: translateY(0) !important;
  opacity: 1 !important;
  pointer-events: all !important;
}
/* Tree hero in card */
.nw-card-tree {
  text-align: center;
  font-size: 52px;
  line-height: 1;
  margin-bottom: 4px;
  animation: nw-tree-sway 4s ease-in-out infinite;
}
@keyframes nw-tree-sway {
  0%,100% { transform: rotate(0deg); }
  50% { transform: rotate(0deg); }
}
.nw-card-greeting {
  text-align: center;
  font-size: 13px;
  font-weight: 640;
  color: rgba(60,60,67,0.55);
  letter-spacing: -0.01em;
  font-family: var(--nlf);
  margin-bottom: 2px;
}
.nw-card-headline {
  text-align: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.04em;
  color: #1c1c1e;
  font-family: var(--nlf);
  margin-bottom: 14px;
}
.nw-card-headline span { color: #1A5C3A; }

/* Progress section */
.nw-progress-label {
  font-size: 12px;
  font-weight: 640;
  color: rgba(60,60,67,0.5);
  letter-spacing: 0.03em;
  text-transform: uppercase;
  font-family: var(--nlf);
  margin-bottom: 8px;
}
.nw-progress-bar-bg {
  height: 8px;
  background: rgba(26,92,58,0.12);
  border-radius: 100px;
  overflow: hidden;
  margin-bottom: 6px;
}
.nw-progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #1A5C3A, #3D6B22);
  border-radius: 100px;
  box-shadow: 0 0 8px rgba(26,92,58,0.5);
  transition: width 1.2s var(--nls);
}
.nw-progress-text {
  font-size: 12px;
  font-weight: 580;
  color: rgba(60,60,67,0.55);
  font-family: var(--nlf);
  margin-bottom: 14px;
}
/* Coupon reveal */
.nw-coupon-box {
  background: linear-gradient(135deg, rgba(26,92,58,0.1), rgba(48,209,88,0.05));
  border: 1.5px dashed rgba(26,92,58,0.4);
  border-radius: 14px;
  padding: 14px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s var(--nls);
  font-family: var(--nlf);
}
.nw-coupon-box:hover { transform: scale(1.02); border-color: #1A5C3A; }
.nw-coupon-code {
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0.1em;
  color: #1A5C3A;
  font-family: var(--nlf);
}
.nw-coupon-sub {
  font-size: 11px;
  font-weight: 600;
  color: rgba(60,60,67,0.5);
  margin-top: 2px;
  font-family: var(--nlf);
}
.nw-next-reward {
  font-size: 12px;
  font-weight: 600;
  color: rgba(60,60,67,0.55);
  text-align: center;
  margin-top: 10px;
  font-family: var(--nlf);
}

/* ============================================================
   CONFETTI — Apple green, super slow, 120fps-smooth
   ============================================================ */
#nw-confetti-canvas {
  position: fixed; inset: 0;
  pointer-events: none;
  z-index: 99998;
}
`;

// Inject CSS
const styleEl = document.createElement('style');
styleEl.id = 'nw-master-css';
document.head.appendChild(styleEl);
styleEl.textContent = css;

// ── 2. GERMAN UI + TITLE CLEANER ───────────────
function clean(t) {
  return t.trim()
    .replace(/^\d+[-_\s]+/, '')
    .split(/[-_]/)
    .map(w => {
      w = w.toLowerCase()
        .replace(/ae/g,'ä').replace(/oe/g,'ö').replace(/ue/g,'ü')
        .replace(/ss(?=[a-z])/g,'ß');
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(' ')
    .replace(/(\d+)\s*[xX×]\s*(\d+)/g,'$1×$2')
    .trim();
}

const sortMap = {
  'Featured': 'Empfohlen', 'Best selling': 'Bestseller', 'Alphabetically, A-Z': 'A–Z',
  'Alphabetically, Z-A': 'Z–A', 'Price, low to high': 'Preis: aufsteigend',
  'Price, high to low': 'Preis: absteigend', 'Date, new to old': 'Neueste zuerst',
  'Date, old to new': 'Älteste zuerst', 'Sort by': 'Sortierung:', 'Availability': 'Verfügbarkeit',
  'Price': 'Preis', 'In stock': 'Verfügbar', 'Out of stock': 'Nicht verfügbar',
  'Add to cart': 'In den Warenkorb', 'Sold out': 'Ausverkauft', 'Sale': 'Angebot',
  'New': 'Neu', 'Loading': 'Laden', 'More': 'Mehr', 'Less': 'Weniger',
  'Filter': 'Filter', 'Clear all': 'Alle löschen', 'Apply': 'Anwenden',
  'from': 'ab', 'To': 'Bis', 'Filter and sort': 'Filtern & sortieren',
  'Your cart is empty': 'Dein Warenkorb ist leer',
  'Your Shopping Cart': 'Dein Warenkorb',
  'Continue shopping': 'Weiter einkaufen',
  'Have an account?': 'Schon ein Konto?',
  'Log in to check out faster.': 'Melde dich an für schnelleren Checkout.',
  'Log in': 'Anmelden',
  'Subtotal': 'Zwischensumme',
  'Taxes and shipping calculated at checkout': 'Steuern und Versand werden beim Checkout berechnet',
  'Check out': 'Zur Kasse',
  'Update': 'Aktualisieren',
  'Remove': 'Entfernen',
  'Quantity': 'Menge',
  'Total': 'Gesamt',
  'Product': 'Produkt',
  'Products': 'Produkte',
  'Search': 'Suche',
  'Sign in': 'Anmelden',
  'Create account': 'Konto erstellen',
  'Email': 'E-Mail',
  'Password': 'Passwort',
  'Forgot your password?': 'Passwort vergessen?',
  'Featured collection': 'Empfohlene Kollektion',
  'Continue browsing': 'Weiter stöbern',
  'Cookie consent': 'Cookie-Einstellungen',
};

function translateDOM(root) {
  root = root || document;
  // Sort options
  root.querySelectorAll('option, .select__select option').forEach(el => {
    const t = el.textContent.trim();
    if (sortMap[t]) el.textContent = sortMap[t];
  });
  // Labels and headings
  root.querySelectorAll('[data-label], .facets__heading, .filter-label, span.visually-hidden, label').forEach(el => {
    const t = el.textContent.trim();
    if (sortMap[t]) el.textContent = sortMap[t];
  });
  // Button texts
  root.querySelectorAll('.button, button, [type="submit"]').forEach(el => {
    const t = el.textContent.trim();
    if (sortMap[t]) el.textContent = sortMap[t];
  });
  // Product titles
  root.querySelectorAll('.card__heading a, .card__heading').forEach(el => {
    const txt = el.textContent.trim();
    if (/^\d|[-_]/.test(txt)) {
      el.textContent = clean(txt);
    }
  });
}

translateDOM();
const obs = new MutationObserver(muts => muts.forEach(m => m.addedNodes.forEach(n => {
  if (n.nodeType === 1) translateDOM(n);
})));
obs.observe(document.body, { childList: true, subtree: true });

// ── 3. SAVINGS BADGE ON SALE CARDS ───────────────
function addSavingsBadges() {
  document.querySelectorAll('.price--on-sale').forEach(el => {
    if (el.querySelector('.price-badge-savings')) return;
    const sale = el.querySelector('.price-item--sale');
    const reg = el.querySelector('.price-item--regular');
    if (!sale || !reg) return;
    const saleN = parseFloat(sale.textContent.replace(/[^\d,.]/g,'').replace(',','.'));
    const regN = parseFloat(reg.textContent.replace(/[^\d,.]/g,'').replace(',','.'));
    if (regN > saleN && regN > 0) {
      const pct = Math.round((1 - saleN/regN) * 100);
      const badge = document.createElement('span');
      badge.className = 'price-badge-savings';
      badge.textContent = `-${pct}%`;
      sale.appendChild(badge);
    }
  });
}
addSavingsBadges();
setTimeout(addSavingsBadges, 1500);

// ── 4. HOMEPAGE — DoktorABC Treatment Page ────────────
function buildHomepage() {
  const isHome = window.location.pathname === '/' || document.body.classList.contains('template-index');
  if (!isHome) return;
  if (document.getElementById('nw-home')) return;

  const CHEVRON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg>';
  const LEAF = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1.27-3.35A9.94 9.94 0 0012 20c5.52 0 10-4.48 10-10 0-4.75-5-8-5-8s-1.77 1.64-3 3"/></svg>';
  const DROP = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/></svg>';
  const CAPSULE = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="6"/><line x1="6" y1="12" x2="18" y2="12"/></svg>';
  const BOX = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>';
  const SHIELD = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>';

  const categories = [
    { icon: LEAF,    bg: 'rgba(26,92,58,0.07)', title: 'Nordwald Reserve',   sub: 'CBD Hautoel — 30ml',   badge: 'neu',  href: '/collections/all' },
    { icon: DROP,    bg: 'rgba(26,92,58,0.06)', title: 'CBD Oele',           sub: '5% / 10% / 20% / 25%', badge: 'soon', href: '/collections/all' },
    { icon: CAPSULE, bg: 'rgba(26,92,58,0.05)', title: 'CBD Kapseln',        sub: '25mg — exakte Dosis',   badge: 'soon', href: '/collections/all' },
    { icon: BOX,     bg: 'rgba(26,92,58,0.06)', title: 'Bundles',            sub: 'Sleep / Starter / Wellness', badge: 'soon', href: '/collections/all' },
    { icon: SHIELD,  bg: 'rgba(26,92,58,0.04)', title: 'Transparenz',        sub: 'Laborberichte & QR-Codes',   badge: null,  href: '/pages/transparenz' },
  ];

  const badgeHTML = (b) => {
    if (!b) return '';
    if (b === 'neu')  return '<span class="nw-cat-badge nw-badge-neu">NEU</span>';
    if (b === 'soon') return '<span class="nw-cat-badge nw-badge-soon">Bald</span>';
    if (b === 'hot')  return '<span class="nw-cat-badge nw-badge-hot">Fast weg</span>';
    return '';
  };

  // Override announcement bar text
  const annBar = document.querySelector('.announcement-bar__message, .announcement-bar p, .announcement-bar a, .announcement-bar span');
  if (annBar) annBar.textContent = 'CBD Hautpflege — laborgeprüft, EU-konform, versandkostenfrei ab 29 EUR';

  const homeEl = document.createElement('div');
  homeEl.id = 'nw-home';
  homeEl.innerHTML = `
    <!-- NAV PILLS (DoktorABC dark rounded buttons) -->
    <div class="nw-nav-pills">
      <a href="/pages/ueber-uns" class="nw-pill">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 00-16 0"/></svg>
        Warum Nordwald
      </a>
      <a href="/pages/transparenz" class="nw-pill">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
        Laborberichte
      </a>
      <a href="/pages/faq" class="nw-pill">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        FAQ
      </a>
      <a href="/collections/all" class="nw-pill">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
        Alle Produkte
      </a>
    </div>

    <!-- PROMO BANNER (DoktorABC hero image area) -->
    <div class="nw-promo-banner">
      <div class="nw-promo-bg"></div>
      <div class="nw-promo-content">
        <div class="nw-promo-eyebrow">Nordwald CBD</div>
        <div class="nw-promo-headline">Hanf-Hautpflege.<br>Laborgeprüft. Ehrlich.</div>
        <div class="nw-promo-sub">Erste Charge limitiert — EU-konform, CPNP-registriert, QR-Code auf jeder Flasche.</div>
        <a href="/collections/all" class="nw-promo-cta">Jetzt entdecken</a>
      </div>
      <div class="nw-promo-visual">
        <svg viewBox="0 0 120 120" width="120" height="120" fill="none">
          <circle cx="60" cy="60" r="56" fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.2)" stroke-width="1"/>
          <path d="M60 25c-8 12-25 22-25 40a25 25 0 0050 0c0-18-17-28-25-40z" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.35)" stroke-width="1.5"/>
          <path d="M55 58c0-8 5-14 5-14s5 6 5 14-2 12-5 12-5-4-5-12z" fill="rgba(255,255,255,0.3)"/>
        </svg>
      </div>
    </div>

    <!-- HERO OFFER (DoktorABC featured treatment) -->
    <a href="/collections/all" class="nw-hero-offer">
      <div class="nw-hero-inner">
        <div class="nw-hero-icon">
          ${LEAF}
        </div>
        <div class="nw-hero-text">
          <div class="nw-hero-badge">Jetzt vorbestellen</div>
          <div class="nw-hero-title">Nordwald Reserve — CBD Hautoel</div>
          <div class="nw-hero-sub">30ml, laborgeprüft, EU-konform. Erste Charge limitiert.</div>
        </div>
        <div class="nw-hero-price">39,90&euro;</div>
        <div class="nw-hero-arrow">${CHEVRON}</div>
      </div>
    </a>

    <!-- TRUST STATS (DoktorABC "3 Mio Bestellungen" bar) -->
    <div class="nw-trust-stats">
      <div class="nw-stat">
        <div class="nw-stat-val">100%</div>
        <div class="nw-stat-label">Laborgeprüft</div>
      </div>
      <div class="nw-stat">
        <div class="nw-stat-val">&lt; 0,2%</div>
        <div class="nw-stat-label">THC-Gehalt</div>
      </div>
      <div class="nw-stat">
        <div class="nw-stat-val">EU</div>
        <div class="nw-stat-label">CPNP-konform</div>
      </div>
      <div class="nw-stat">
        <div class="nw-stat-val">QR</div>
        <div class="nw-stat-label">Jede Flasche</div>
      </div>
    </div>

    <!-- SECTION: Behandlungen / Sortiment -->
    <div class="nw-section-label">Alle Produkte</div>
    <div class="nw-section-sub">Waehle eine Kategorie</div>

    <div class="nw-card-grid">
      ${categories.map(c => `
        <a href="${c.href}" class="nw-cat-card">
          <div class="nw-cat-icon" style="background:${c.bg};">${c.icon}</div>
          <div class="nw-cat-text">
            <div class="nw-cat-title">${c.title}</div>
            <div class="nw-cat-sub">${c.sub}</div>
            ${badgeHTML(c.badge)}
          </div>
          <div class="nw-cat-arrow">${CHEVRON}</div>
        </a>
      `).join('')}
    </div>
  `;

  // Hide ALL old content, inject Nordwald homepage
  Array.from(document.body.children).forEach(child => {
    if (child.tagName !== 'SCRIPT' && child.tagName !== 'LINK' && child.tagName !== 'STYLE'
        && child.id !== 'nw-home' && !child.classList.contains('shopify-pc__banner')) {
      child.style.display = 'none';
    }
  });
  document.body.insertBefore(homeEl, document.body.firstChild);
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(buildHomepage, 200);
} else {
  document.addEventListener('DOMContentLoaded', () => setTimeout(buildHomepage, 200));
}

// ── 5. TREUE-BAUM WIDGET ──────────────────────────
(function() {
  const VISITS_KEY = 'nw_visits';
  const LAST_KEY = 'nw_last';

  // Count visit (once per session)
  if (!sessionStorage.getItem('nw_counted')) {
    sessionStorage.setItem('nw_counted', '1');
    const v = parseInt(localStorage.getItem(VISITS_KEY) || '0') + 1;
    localStorage.setItem(VISITS_KEY, v);
    localStorage.setItem(LAST_KEY, Date.now());
  }

  const visits = parseInt(localStorage.getItem(VISITS_KEY) || '1');

  // Milestones
  const milestones = [3, 7, 15, 30, 50];
  const coupons    = ['TREUE5', 'TREUE10', 'TREUE15', 'TREUE20', 'TREUE25'];
  const discounts  = ['5%', '10%', '15%', '20%', '25%'];

  let mIdx = milestones.findIndex(m => visits < m);
  if (mIdx === -1) mIdx = milestones.length - 1;

  const prevMs = mIdx > 0 ? milestones[mIdx - 1] : 0;
  const nextMs = milestones[mIdx];
  const progress = Math.min((visits - prevMs) / (nextMs - prevMs), 1);
  const circ = Math.PI * 2 * 34; // r=34 → circumference ≈ 213.6

  // Unlocked coupon?
  const unlockedIdx = milestones.findLastIndex(m => visits >= m);
  const hasReward = unlockedIdx >= 0;
  const couponCode = hasReward ? coupons[unlockedIdx] : null;
  const discount = hasReward ? discounts[unlockedIdx] : null;
  const remVisits = nextMs - visits;

  // Build widget — Clean Professional Design
  const widget = document.createElement('div');
  widget.id = 'nw-treue-widget';

  // Orb-Farbe basierend auf Level
  const orbColors = ['#1A5C3A','#3D6B22','#4A7C2E','#6B8F4E','#B8860B'];
  const orbCol = hasReward ? orbColors[Math.min(unlockedIdx, 4)] : '#1A5C3A';

  widget.innerHTML = `
    <div id="nw-treue-card">
      <div style="display:flex;align-items:center;gap:12px;margin-bottom:16px;">
        <div style="width:44px;height:44px;border-radius:12px;background:linear-gradient(135deg,${orbCol},${orbCol}dd);display:flex;align-items:center;justify-content:center;">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C17 10.76 14.76 13 12 13S7 10.76 7 8c0-2.76 2.24-5 5-5s5 2.24 5 5z"/><path d="M12 13v9"/><path d="M9 18h6"/></svg>
        </div>
        <div>
          <div style="font-size:17px;font-weight:720;color:#1c1c1e;letter-spacing:-0.02em;font-family:var(--nlf);">Treue-Programm</div>
          <div style="font-size:13px;color:rgba(60,60,67,0.5);font-family:var(--nlf);">${visits}. Besuch</div>
        </div>
      </div>

      ${hasReward ? `
        <div style="background:linear-gradient(135deg,rgba(26,92,58,0.06),rgba(26,92,58,0.02));border:1px solid rgba(26,92,58,0.12);border-radius:14px;padding:16px;cursor:pointer;transition:all 0.3s ease;" onclick="navigator.clipboard.writeText('${couponCode}').then(()=>{this.querySelector('[data-code]').textContent='Kopiert';setTimeout(()=>{this.querySelector('[data-code]').textContent='${couponCode}'},1800)})">
          <div style="font-size:11px;font-weight:680;color:rgba(60,60,67,0.45);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:6px;font-family:var(--nlf);">Dein Rabatt</div>
          <div style="display:flex;align-items:center;justify-content:space-between;">
            <div data-code style="font-size:20px;font-weight:800;letter-spacing:0.08em;color:#1A5C3A;font-family:var(--nlf);">${couponCode}</div>
            <div style="font-size:24px;font-weight:800;color:#1A5C3A;font-family:var(--nlf);">${discount}</div>
          </div>
          <div style="font-size:12px;color:rgba(60,60,67,0.4);margin-top:4px;font-family:var(--nlf);">Antippen zum Kopieren</div>
        </div>
        <div style="font-size:12px;color:rgba(60,60,67,0.45);text-align:center;margin-top:12px;font-family:var(--nlf);">Noch ${remVisits} Besuche bis ${discounts[unlockedIdx + 1] || '30%'}</div>
      ` : `
        <div style="margin-bottom:6px;">
          <div style="display:flex;justify-content:space-between;margin-bottom:8px;">
            <span style="font-size:12px;font-weight:640;color:rgba(60,60,67,0.5);text-transform:uppercase;letter-spacing:0.04em;font-family:var(--nlf);">Fortschritt</span>
            <span style="font-size:12px;font-weight:680;color:#1A5C3A;font-family:var(--nlf);">${Math.round(progress*100)}%</span>
          </div>
          <div style="height:6px;background:rgba(26,92,58,0.08);border-radius:100px;overflow:hidden;">
            <div style="height:100%;width:${Math.round(progress*100)}%;background:linear-gradient(90deg,#1A5C3A,#4A7C2E);border-radius:100px;transition:width 1s cubic-bezier(0.32,0.72,0,1);"></div>
          </div>
        </div>
        <div style="font-size:13px;color:rgba(60,60,67,0.5);font-family:var(--nlf);">Noch ${remVisits} Besuche bis ${discounts[mIdx]} Rabatt</div>
        <div style="display:flex;gap:6px;margin-top:12px;">
          ${milestones.map((m,i)=>`<div style="flex:1;text-align:center;padding:6px 0;border-radius:8px;font-size:11px;font-weight:680;font-family:var(--nlf);${visits>=m?'background:rgba(26,92,58,0.08);color:#1A5C3A;':'color:rgba(60,60,67,0.3);background:rgba(0,0,0,0.02);'}">${m}</div>`).join('')}
        </div>
      `}
    </div>
    <div id="nw-treue-orb" style="background:linear-gradient(145deg,${orbCol},${orbCol}cc) !important;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 8C17 10.76 14.76 13 12 13S7 10.76 7 8c0-2.76 2.24-5 5-5s5 2.24 5 5z"/><path d="M12 13v9"/><path d="M9 18h6"/></svg>
      <svg id="nw-ring-svg" viewBox="0 0 80 80">
        <circle class="nw-ring-bg" cx="40" cy="40" r="34"/>
        <circle class="nw-ring-progress" cx="40" cy="40" r="34"
          stroke-dasharray="${progress * 2 * Math.PI * 34} ${2 * Math.PI * 34}"/>
      </svg>
      ${hasReward ? `<div id="nw-treue-badge" style="background:linear-gradient(135deg,#1A5C3A,#4A7C2E) !important;">${discount}</div>` : `<div id="nw-treue-badge" style="background:linear-gradient(135deg,#1A5C3A,#4A7C2E) !important;">${visits}</div>`}
    </div>
  `;

  document.body.appendChild(widget);

  let open = false;
  document.getElementById('nw-treue-orb').addEventListener('click', () => {
    open = !open;
    document.getElementById('nw-treue-card').classList.toggle('nw-open', open);
    const orb = document.getElementById('nw-treue-orb');
    if (open) {
      orb.style.transform = 'scale(1.03)';
      setTimeout(() => orb.style.transform = '', 300);
    }
  });

  // Animate ring draw on load
  const ring = document.querySelector('.nw-ring-progress');
  if (ring) {
    ring.style.strokeDasharray = `0 ${2 * Math.PI * 34}`;
    setTimeout(() => {
      ring.style.transition = 'stroke-dasharray 1.8s cubic-bezier(0.32,0.72,0,1)';
      ring.style.strokeDasharray = `${progress * 2 * Math.PI * 34} ${2 * Math.PI * 34}`;
    }, 600);
  }
})();

// ── 6. APPLE CONFETTI (green, slow, dopamine) ──────
window._nwConfetti = function(cx, cy) {
  let canvas = document.getElementById('nw-confetti-canvas');
  if (!canvas) {
    canvas = document.createElement('canvas');
    canvas.id = 'nw-confetti-canvas';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);
  }
  const ctx = canvas.getContext('2d');
  const colors = ['#1A5C3A','#3D6B22','#4A7C2E','#6B8F4E','#8BAF6E','#A8C98E','#C4DFB0','#FFD700','#FFFFFF'];
  const shapes = ['●','◆','▲','⬟','★','✦'];
  const parts = Array.from({length:60}, () => ({
    x: cx, y: cy,
    vx: (Math.random()-0.5) * 5,
    vy: -(Math.random() * 6 + 3),
    rot: Math.random() * 360,
    rotV: (Math.random()-0.5) * 3,
    size: Math.random() * 9 + 5,
    color: colors[Math.floor(Math.random()*colors.length)],
    shape: shapes[Math.floor(Math.random()*shapes.length)],
    alpha: 1,
    scaleY: 1,
  }));
  let last = performance.now();
  function frame(now) {
    const dt = Math.min((now - last) / 16.67, 2);
    last = now;
    ctx.clearRect(0,0,canvas.width,canvas.height);
    let alive = 0;
    parts.forEach(p => {
      p.vy += 0.06 * dt;
      p.vx *= Math.pow(0.994, dt);
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.rotV * dt;
      p.alpha -= 0.004 * dt;
      p.scaleY = 0.8 + 0.2 * Math.sin(p.rot * 0.06);
      if (p.alpha > 0) alive++;
      ctx.save();
      ctx.globalAlpha = Math.max(0, p.alpha);
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot * Math.PI/180);
      ctx.scale(1, p.scaleY);
      ctx.fillStyle = p.color;
      ctx.font = `${p.size}px serif`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(p.shape, 0, 0);
      ctx.restore();
    });
    if (alive > 0) requestAnimationFrame(frame);
    else ctx.clearRect(0,0,canvas.width,canvas.height);
  }
  requestAnimationFrame(frame);
};

// Attach confetti to add-to-cart
document.addEventListener('click', e => {
  const btn = e.target.closest('[name="add"], .add-to-cart, .cart__add-button, .product-form__submit');
  if (btn) {
    const r = btn.getBoundingClientRect();
    window._nwConfetti(r.left + r.width/2, r.top + r.height/2);
  }
}, {passive:true});

// ── 7. HONIG HAPTIC FEEDBACK (smooth, kein Bounce) ──
document.addEventListener('click', e => {
  const el = e.target.closest('.card, .nw-cat-card, .button');
  if (!el) return;
  el.style.transition = 'transform 0.15s cubic-bezier(0.32,0.72,0,1)';
  el.style.transform = 'translateY(1px)';
  setTimeout(() => {
    el.style.transition = 'transform 0.4s cubic-bezier(0.32,0.72,0,1)';
    el.style.transform = '';
  }, 150);
}, {passive:true});

// ── 8. APPLE STORE SEARCH BAR (Homepage only) ────
(function buildSearchBar() {
  if (document.getElementById('nw-search-bar')) return;
  const isHome = window.location.pathname === '/' || document.body.classList.contains('template-index');
  if (!isHome) return;

  const bar = document.createElement('div');
  bar.id = 'nw-search-bar';
  bar.innerHTML = `
    <div id="nw-search-inner">
      <span id="nw-search-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg></span>
      <input id="nw-search-input" type="text" placeholder="Produkte suchen…" autocomplete="off" />
      <span id="nw-search-clear" style="display:none">✕</span>
    </div>
    <div id="nw-search-results"></div>
  `;

  // Search CSS is now in main CSS block above — only result-specific additions here
  const sCSS = document.createElement('style');
  sCSS.textContent = `
    #nw-search-clear {
      font-size: 13px; color: rgba(60,60,67,0.4);
      cursor: pointer; width: 22px; height: 22px;
      background: rgba(60,60,67,0.12); border-radius: 50%;
      display: flex !important; align-items: center; justify-content: center;
      flex-shrink: 0; font-style: normal; transition: all 0.2s ease;
    }
    #nw-search-results {
      margin-top: 8px; border-radius: 14px;
      background: #fff; border: 1px solid rgba(0,0,0,0.06);
      box-shadow: 0 4px 16px rgba(0,0,0,0.08);
      overflow: hidden; max-height: 0;
      transition: max-height 0.35s cubic-bezier(0.32,0.72,0,1);
    }
    #nw-search-results.nw-active { max-height: 420px; overflow-y: auto; }
    .nw-search-result {
      display: flex; align-items: center; gap: 12px;
      padding: 12px 16px; background: #fff;
      border-bottom: 1px solid rgba(0,0,0,0.04);
      cursor: pointer; text-decoration: none;
      transition: background 0.15s ease;
      font-family: var(--nlf);
    }
    .nw-search-result:hover { background: #f8f8fa; }
    .nw-search-result:last-child { border-bottom: none; }
    .nw-sr-img { width: 44px; height: 44px; border-radius: 10px; object-fit: cover; flex-shrink: 0; }
    .nw-sr-title { font-size: 15px; font-weight: 620; color: #1c1c1e; letter-spacing: -0.01em; }
    .nw-sr-price { font-size: 13px; color: var(--nl); font-weight: 700; }
    .nw-sr-empty { padding: 20px; text-align: center; color: rgba(60,60,67,0.45); font-size: 14px; font-family: var(--nlf); }
  `;
  document.head.appendChild(sCSS);

  // Insert after header
  const header = document.querySelector('.header-wrapper, header, .site-header');
  if (header) header.after(bar);
  else document.body.insertBefore(bar, document.body.firstChild);

  // Search logic
  const input = bar.querySelector('#nw-search-input');
  const results = bar.querySelector('#nw-search-results');
  const clearBtn = bar.querySelector('#nw-search-clear');

  let debounce;
  input.addEventListener('input', function() {
    clearTimeout(debounce);
    const q = this.value.trim();
    clearBtn.style.display = q ? 'flex' : 'none';
    if (!q) { results.classList.remove('nw-active'); results.innerHTML = ''; return; }
    debounce = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
        .then(r => r.json()).then(data => {
          const prods = data.resources?.results?.products || [];
          results.classList.add('nw-active');
          if (!prods.length) {
            results.innerHTML = `<div class="nw-sr-empty">Keine Produkte gefunden für „${q}"</div>`;
            return;
          }
          results.innerHTML = prods.map(p => `
            <a href="${p.url}" class="nw-search-result">
              ${p.featured_image?.url ? `<img class="nw-sr-img" src="${p.featured_image.url.replace('?', '?width=88&')}" alt="">` : '<div class="nw-sr-img" style="background:rgba(26,92,58,0.08)"></div>'}
              <div>
                <div class="nw-sr-title">${p.title}</div>
                <div class="nw-sr-price">${p.price ? (parseFloat(p.price)/100).toFixed(2).replace('.',',') + ' €' : ''}</div>
              </div>
            </a>
          `).join('');
        }).catch(() => {
          results.innerHTML = `<div class="nw-sr-empty">Suche nicht verfügbar</div>`;
        });
    }, 250);
  });

  clearBtn.addEventListener('click', () => {
    input.value = ''; clearBtn.style.display = 'none';
    results.classList.remove('nw-active'); results.innerHTML = '';
    input.focus();
  });

  // Close on outside click
  document.addEventListener('click', e => {
    if (!bar.contains(e.target)) {
      results.classList.remove('nw-active');
    }
  }, { passive: true });
})();

// ── 9. PRODUKTE VERSTECKEN (Pre-Launch) ────────────
// Alle Produkte unsichtbar + nicht kaufbar bis Oel da ist
// Entferne diesen Block wenn das Oel live ist
(function hideProductsPreLaunch() {
  const hideCSS = document.createElement('style');
  hideCSS.id = 'nw-prelaunch-hide';
  hideCSS.textContent = `
    /* Produkt-Karten komplett verstecken */
    .product-grid .grid__item,
    .product-grid .card-wrapper,
    .collection-product-list .grid__item,
    [class*="product-card"],
    .card-wrapper[class*="product"] {
      display: none !important;
    }

    /* Add-to-Cart + Sold-Out Buttons auf Produktseiten */
    .product-form__submit,
    .shopify-payment-button,
    .product-form__buttons,
    .product-form__cart-submit {
      display: none !important;
    }

    /* Produkt-Preise verstecken */
    .product-grid .price,
    .card .price {
      display: none !important;
    }

    /* Coming Soon Overlay auf Collection-Seiten */
    .collection .page-width::before,
    body.template-collection .main-content::before {
      content: '';
      display: block;
      text-align: center;
      padding: 60px 20px;
      font-family: var(--nlf);
    }
  `;
  document.head.appendChild(hideCSS);

  // Coming-Soon Banner auf Collection-Seiten
  function addComingSoon() {
    const isCollection = document.body.classList.contains('template-collection') ||
                         window.location.pathname.includes('/collections/');
    const isProduct = document.body.classList.contains('template-product') ||
                      window.location.pathname.includes('/products/');

    if (isCollection || isProduct) {
      if (document.getElementById('nw-coming-soon')) return;
      const banner = document.createElement('div');
      banner.id = 'nw-coming-soon';
      banner.style.cssText = 'text-align:center;padding:60px 20px 40px;font-family:var(--nlf);';
      const chk = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg>';
      const products = [
        { name: 'Nordwald Reserve Hautoel', detail: '30ml CBD Hautoel', price: '39,90 EUR', sku: 'NW-R-001' },
        { name: 'CBD Oel 5%', detail: '500mg / 10ml Vollspektrum', price: '19,90 EUR', sku: 'NW-O-005' },
        { name: 'CBD Oel 10%', detail: '1000mg / 10ml Vollspektrum', price: '29,90 EUR', sku: 'NW-O-010' },
        { name: 'CBD Oel 20%', detail: '2000mg / 10ml Power', price: '44,90 EUR', sku: 'NW-O-020' },
        { name: 'CBD Kapseln 25mg', detail: '60 Kapseln, vegan', price: '34,90 EUR', sku: 'NW-K-025' },
        { name: 'Sleep Well Bundle', detail: 'Oel 10% + CBN + Kapseln', price: '68,00 EUR', sku: 'NW-B-SLP' },
        { name: 'Nordwald Starter', detail: 'Kapseln + Tee + Oel 10%', price: '72,00 EUR', sku: 'NW-B-STR' },
      ];
      banner.innerHTML = `
        <h2 style="font-size:22px;font-weight:800;letter-spacing:-0.03em;color:#1c1c1e;margin:0 0 6px;font-family:var(--nlf);">Sortiment</h2>
        <p style="font-size:14px;color:rgba(60,60,67,0.5);margin:0 0 20px;font-family:var(--nlf);">Wird vorbereitet — alle Produkte laborgeprüft und CPNP-registriert.</p>
        <div style="max-width:520px;margin:0 auto;">
          ${products.map(p => `
            <div style="display:flex;align-items:center;gap:14px;padding:14px 16px;background:#fff;border:1px solid rgba(0,0,0,0.06);border-radius:14px;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,0.04),0 4px 12px rgba(0,0,0,0.03);font-family:var(--nlf);">
              <div style="width:48px;height:48px;border-radius:12px;background:linear-gradient(135deg,rgba(26,92,58,0.08),rgba(26,92,58,0.04));display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                ${chk}
              </div>
              <div style="flex:1;min-width:0;">
                <div style="font-size:15px;font-weight:660;color:#1c1c1e;letter-spacing:-0.01em;">${p.name}</div>
                <div style="font-size:12px;color:rgba(60,60,67,0.5);margin-top:1px;">${p.detail}</div>
              </div>
              <div style="font-size:15px;font-weight:720;color:#1A5C3A;white-space:nowrap;">${p.price}</div>
            </div>
          `).join('')}
        </div>
      `;
      const main = document.querySelector('#nw-home') || document.body;
      main.insertBefore(banner, main.firstChild);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(addComingSoon, 300);
  } else {
    document.addEventListener('DOMContentLoaded', () => setTimeout(addComingSoon, 300));
  }
})();

// ── 10. BOTTOM BAR ENTFERNEN ────────────────────────
(function removeBottomBar() {
  const css = `
    /* Shopify bottom bar / cart drawer overlay weg */
    .cart-notification, .cart-notification-wrapper,
    [id*="cart-notification"], .shopify-payment-button__more-options,
    .cart__footer-items--secondary > *:not(.shopify-payment-button),
    .bottom-bar, [class*="bottom-bar"] { display: none !important; }
  `;
  const s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);
})();

// ── 10. JETZT KAUFEN — Apple style, single, prominent ──
(function styleKaufenButton() {
  const css = `
    /* "Jetzt kaufen" = Shopify Payment Button (DoktorABC) */
    .shopify-payment-button__button--branded {
      border-radius: 12px !important;
      min-height: 54px !important;
      font-size: 17px !important;
      font-weight: 700 !important;
      letter-spacing: -0.02em !important;
      box-shadow: 0 6px 24px rgba(0,0,0,0.22) !important;
      transition: all 0.38s cubic-bezier(0.32,0.72,0,1) !important;
      margin-top: 10px !important;
    }
    .shopify-payment-button__button--branded:hover {
      transform: translateY(-2px) scale(1.015) !important;
      box-shadow: 0 12px 36px rgba(0,0,0,0.28) !important;
    }
    .shopify-payment-button { margin-top: 12px !important; }

    /* Payment icons row on cart/checkout */
    .nw-payment-icons {
      display: flex; flex-wrap: wrap; gap: 6px;
      justify-content: center; padding: 14px 0 4px;
    }
    .nw-pay-chip {
      height: 28px; padding: 0 10px;
      background: rgba(255,255,255,0.9);
      border: 1px solid rgba(60,60,67,0.12);
      border-radius: 8px;
      font-size: 11px; font-weight: 700;
      color: #1c1c1e; font-family: var(--nlf);
      display: flex; align-items: center; gap: 4px;
      box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    }
  `;
  const s = document.createElement('style'); s.textContent = css;
  document.head.appendChild(s);

  // Add payment icons below product form
  function addPayIcons() {
    document.querySelectorAll('.shopify-payment-button').forEach(el => {
      if (el.nextElementSibling?.classList?.contains('nw-payment-icons')) return;
      const icons = document.createElement('div');
      icons.className = 'nw-payment-icons';
      icons.innerHTML = [
        ['Apple Pay'],
        ['Google Pay'],
        ['PayPal'],
        ['Kreditkarte'],
        ['SEPA'],
        ['Klarna'],
        ['Sofort'],
        ['Mollie'],
      ].map(([l]) => `<div class="nw-pay-chip"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1A5C3A" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg> ${l}</div>`).join('');
      el.after(icons);
    });
  }
  setTimeout(addPayIcons, 800);
  setTimeout(addPayIcons, 2000);
})();

// ── 11. iOS 26 DEPTH SYSTEM ────────────────────────
// Unterschied zu iOS 18: echte Elevation-Ebenen, Farb-Schatten, dynamische Blur-Intensität
(function addDepthSystem() {
  const depthCSS = `
    /* === iOS 26 Elevation Layers === */
    /* Layer 0: Hintergrund (body) */
    /* Layer 1: Karten */
    /* Layer 2: Buttons */
    /* Layer 3: Modals / Widget */

    /* Karten: Farbiger Schatten statt schwarz-grau */
    .card, .card__inner {
      box-shadow:
        0 2px 8px rgba(26,92,58,0.08),
        0 8px 32px rgba(26,92,58,0.10),
        0 20px 60px rgba(26,92,58,0.06),
        inset 0 1px 0 rgba(255,255,255,0.95),
        inset 0 -1px 0 rgba(26,92,58,0.04) !important;
    }
    .card-wrapper:hover .card {
      box-shadow:
        0 4px 12px rgba(26,92,58,0.12),
        0 16px 48px rgba(26,92,58,0.18),
        0 32px 80px rgba(26,92,58,0.08),
        inset 0 1px 0 rgba(255,255,255,1),
        inset 0 -1px 0 rgba(26,92,58,0.06) !important;
    }

    /* Innenlicht — Liquid Glass shimmer */
    .card::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: radial-gradient(
        ellipse at 20% 10%,
        rgba(255,255,255,0.45) 0%,
        rgba(255,255,255,0.08) 50%,
        transparent 70%
      );
      pointer-events: none;
      z-index: 1;
    }

    /* Buttons — iOS 26 Liquid Glass Highlight */
    .button::after {
      content: '';
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 50%;
      border-radius: inherit;
      background: linear-gradient(180deg, rgba(255,255,255,0.22) 0%, transparent 100%);
      pointer-events: none;
    }

    /* Header — stärkeres Frosted Glass */
    .header-wrapper {
      box-shadow:
        0 1px 0 rgba(255,255,255,0.98),
        0 2px 0 rgba(26,92,58,0.04),
        0 4px 30px rgba(0,0,0,0.06),
        0 8px 60px rgba(26,92,58,0.04) !important;
    }

    /* Product-Form — 3D Karte */
    .product-form {
      box-shadow:
        0 4px 16px rgba(26,92,58,0.08),
        0 12px 48px rgba(26,92,58,0.10),
        0 24px 80px rgba(0,0,0,0.06),
        inset 0 1px 0 rgba(255,255,255,0.98),
        inset 0 -2px 0 rgba(26,92,58,0.05) !important;
    }

    /* Treue-Widget — höchste Elevation */
    #nw-treue-orb {
      box-shadow:
        0 4px 16px rgba(26,92,58,0.35),
        0 12px 40px rgba(26,92,58,0.28),
        0 24px 64px rgba(26,92,58,0.15),
        inset 0 1px 0 rgba(255,255,255,0.6),
        inset 0 -2px 0 rgba(0,100,40,0.15) !important;
    }

    /* Search Bar — clean shadow */
    #nw-search-bar {
      box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
    }
  `;
  const s = document.createElement('style'); s.textContent = depthCSS;
  document.head.appendChild(s);
})();

// ── 12. HONEY-PRESS EFFECT — iOS 26 Haptic Feel ───
// Wie Honig eindrücken: weiches Einsinken, leichter Inset-Schatten, Spring zurück
(function addHoneyPress() {
  const honeyCss = `
    /* Basis-Transition für alle interaktiven Elemente */
    .card, .card-wrapper, .button, .btn, .nw-cat-card,
    .nw-treue-orb, #nw-treue-orb, .nw-coupon-box,
    .product-form__submit, [type="submit"],
    .facets__summary, .select__select, .shopify-payment-button__button--branded {
      transition:
        transform 0.38s cubic-bezier(0.32,0.72,0,1),
        box-shadow 0.32s ease,
        filter 0.2s ease !important;
      will-change: transform, box-shadow !important;
    }

    /* Active state — Honig-Dip (kein Bounce, nur smooth sink) */
    .nw-pressed {
      transform: translateY(1px) !important;
      filter: brightness(0.975) !important;
      transition:
        transform 0.18s cubic-bezier(0.32,0.72,0,1),
        box-shadow 0.18s ease,
        filter 0.15s ease !important;
    }

    /* Card press */
    .card-wrapper.nw-pressed .card {
      box-shadow:
        0 1px 4px rgba(26,92,58,0.08),
        0 2px 16px rgba(26,92,58,0.06),
        inset 0 2px 6px rgba(26,92,58,0.06) !important;
    }

    /* Button press */
    .button.nw-pressed, [type="submit"].nw-pressed {
      box-shadow:
        0 1px 4px rgba(26,92,58,0.2),
        inset 0 2px 8px rgba(0,0,0,0.12) !important;
    }

    /* Card press */
    .nw-cat-card.nw-pressed {
      background: rgba(26,92,58,0.03) !important;
    }
  `;
  const s = document.createElement('style'); s.textContent = honeyCss;
  document.head.appendChild(s);

  const targets = '.card-wrapper, .button, .btn, .nw-cat-card, #nw-treue-orb, .nw-coupon-box, .product-form__submit, [type="submit"], .shopify-payment-button__button--branded, .facets__summary';

  // Use event delegation for performance
  document.addEventListener('pointerdown', e => {
    const el = e.target.closest(targets);
    if (!el || el.closest('#nw-treue-card')) return; // skip card interior
    el.classList.add('nw-pressed');
  }, { passive: true });

  const releaseHoney = e => {
    const el = e.target.closest(targets) || document.querySelector('.nw-pressed');
    document.querySelectorAll('.nw-pressed').forEach(el => el.classList.remove('nw-pressed'));
  };

  document.addEventListener('pointerup', releaseHoney, { passive: true });
  document.addEventListener('pointercancel', releaseHoney, { passive: true });
  document.addEventListener('pointerleave', releaseHoney, { passive: true });
})();

// ── 13. LIQUID RIPPLE (iOS 26 Touch Feedback) ─────
// Sanfter Kreis-Ripple beim Antippen — wie Honig der sich ausbreitet
(function addRipple() {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes nw-ripple {
      0% { transform: scale(0); opacity: 0.18; }
      100% { transform: scale(3); opacity: 0; }
    }
    .nw-ripple-el {
      position: absolute; border-radius: 50%;
      width: 80px; height: 80px;
      margin: -40px 0 0 -40px;
      background: rgba(26,92,58,0.08);
      pointer-events: none;
      animation: nw-ripple 0.55s cubic-bezier(0.32,0.72,0,1) forwards;
      z-index: 10;
    }
    .card, .button, .nw-cat-card, .nw-coupon-box { overflow: hidden; position: relative; }
  `;
  document.head.appendChild(style);

  document.addEventListener('pointerdown', e => {
    const el = e.target.closest('.card-wrapper .card, .button, .nw-cat-card, .nw-coupon-box');
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'nw-ripple-el';
    ripple.style.left = (e.clientX - rect.left) + 'px';
    ripple.style.top = (e.clientY - rect.top) + 'px';
    el.appendChild(ripple);
    setTimeout(() => ripple.remove(), 700);
  }, { passive: true });
})();

// Tabs + Trust-Bar removed — DoktorABC uses flat category navigation, no tab system

console.log('[Nordwald v5] DoktorABC Treatment-Card System active');
})();
